module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel06_770_280_th-e5d5385d7f1b251bbbf7211a6a6cbfd3.jpg";